import type { ComponentProps } from 'react';
import type { PopoverContent } from '@crono-one/design-system';

/**
 * Positioning props for an overlay whose trigger can scroll away, e.g. inside a
 * table cell (see `useTableOverlayProps`). Leave them out anywhere else.
 */
export type OverlayProps = Pick<
  ComponentProps<typeof PopoverContent>,
  'hideWhenDetached' | 'collisionPadding' | 'collisionBoundary'
>;

type Side = 'top' | 'right' | 'bottom' | 'left';

/** Where the overlay opens, relative to its trigger. */
export type OverlayPlacement = Side | `${Side}-start` | `${Side}-end`;

type Align = 'start' | 'center' | 'end';

export const toSideAndAlign = (
  placement: OverlayPlacement,
): { side: Side; align: Align } => {
  const [side, align = 'center'] = placement.split('-') as [Side, Align?];
  return { side, align };
};
